export default {"src":"/uk/_next/static/media/spot-remote-working.98e23c62.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};